import React from 'react';
import PropTypes from 'prop-types';
import { Pencil } from 'lucide-react';
import clsx from 'clsx';

const EditableDisplayField = ({
  label,
  value,
  onEdit,
  isDark = false,
  className = ''
}) => {
  const containerClassName = clsx(
    'flex flex-row items-center gap-2',
    className
  );

  const labelClassName = clsx(
    'text-sm font-semibold',
    {
      'text-slate-400': isDark,
      'text-gray-600': !isDark
    }
  );

  const valueClassName = clsx(
    'text-sm',
    {
      'text-slate-200': isDark,
      'text-gray-900': !isDark
    }
  );

  const buttonClassName = clsx(
    'p-1 rounded hover:bg-gray-100 transition-colors',
    {
      'hover:bg-slate-700': isDark,
      'hover:bg-gray-100': !isDark
    }
  );

  const iconClassName = clsx(
    'w-3.5 h-3.5',
    {
      'text-slate-400': isDark,
      'text-gray-500': !isDark
    }
  );

  return (
    <div className={containerClassName}>
      <span className={labelClassName}>{label}</span>
      <span className={valueClassName}>{value}</span>
      {onEdit && (
        <button
          type="button"
          onClick={onEdit}
          className={buttonClassName}
          aria-label={`Edit ${label}`}
        >
          <Pencil className={iconClassName} />
        </button>
      )}
    </div>
  );
};

EditableDisplayField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  onEdit: PropTypes.func,
  isDark: PropTypes.bool,
  className: PropTypes.string
};

export default EditableDisplayField;